import { Stack } from '@mui/system';
import { iconPadding } from 'components/management/customDashboard/CustomWidgetCloseAction';
import { updateWidgetState, useWidgetState } from 'components/management/customDashboard/CustomWidgetContext';
import WidgetSettings from 'components/management/customDashboard/WidgetSettings';
import { calculateDefaultPresetRange } from 'components/management/TilesDateRangeSelector';
import type { PredefinedRange } from 'components/predefinedDateRanges';
import { defaultRowSpacing } from 'components/StackSpacing';
import { FormPredefinedDateRangeInput } from 'components/technical/form/FormPredefinedDateRangeInput';
import { FormPortfolioFilters } from 'components/technical/form/FormPortfolioFilters';
import gYupResolver from 'components/technical/form/gYupResolver';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  type PortfolioFilters,
  portfolioFiltersSchema,
} from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';

const schema = yup
  .object({
    title: yup.string().required(),
    predefinedDateRange: yup.object().required(),
  })
  .concat(portfolioFiltersSchema);

export interface ProfitLossSettingsState extends Partial<PortfolioFilters> {
  title: string;
  predefinedDateRange: PredefinedRange;
}

export const ProfitLossSettings = ({
  id,
  onFinishedEditing,
  onRemovedWidget,
}: {
  id: string;
  onFinishedEditing: () => void;
  onRemovedWidget: () => Promise<void>;
}) => {
  const initialState = useWidgetState<ProfitLossSettingsState>(id);
  const updater = updateWidgetState<ProfitLossSettingsState>();

  const methods = useForm<ProfitLossSettingsState>({
    resolver: gYupResolver(schema),
    defaultValues: {
      ...initialState,
      predefinedDateRange: calculateDefaultPresetRange(initialState.predefinedDateRange?.label),
    },
  });

  const handleFormSubmit = async (input: ProfitLossSettingsState): Promise<void> => {
    await updater({
      id,
      state: {
        ...input,
        title: input.title,
        predefinedDateRange: input.predefinedDateRange,
      },
      updateBackend: true,
    });

    onFinishedEditing();
  };

  return (
    <WidgetSettings methods={methods} handleFormSubmit={handleFormSubmit} onRemovedWidget={onRemovedWidget}>
      <Stack pr={iconPadding} width={'100%'} rowGap={defaultRowSpacing}>
        <FormPredefinedDateRangeInput name={'predefinedDateRange'} label={'Date range'} />
        <FormPortfolioFilters />
      </Stack>
    </WidgetSettings>
  );
};
